import { Component, OnDestroy, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-participantes-tercer-sorteo-oportuno-2026',
  templateUrl: './participantes-tercer-sorteo-oportuno-2026.component.html',
  styleUrls: ['./participantes-tercer-sorteo-oportuno-2026.component.scss']
})
export class ParticipantesTercerSorteoOportuno2026Component implements OnInit, OnDestroy {

  dataNuevos: any[] = [];
  filteredData: any[] = [];
  searchText: string = '';
  p: number = 1;

  constructor() {
    this.loadExcel();
  }

  // La barra de "Mi Wallet" vive en el header compartido; esta clase en
  // el body deja subirla solo en esta pagina (ver _header.scss).
  ngOnInit(): void {
    document.body.classList.add('pagina-tercer-oportuno');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('pagina-tercer-oportuno');
  }

  loadExcel() {
    const url = 'assets/pdf/participantesso1.xlsx';
    fetch(url)
      .then(response => response.arrayBuffer())
      .then(buffer => {
        const workbook = XLSX.read(buffer, { type: 'array' });

        // CAMBIO AQUÍ: Cambiado 'ganadores' por 'participantes' para que coincida con tu Excel
        const sheetNuevos = workbook.Sheets['participantes'];

        // 'raw: false' obliga a XLSX a mantener los ceros a la izquierda (ej: "000005" se queda como texto)
        this.dataNuevos = XLSX.utils.sheet_to_json(sheetNuevos, { raw: false });

        // Inicializa el filtro con los datos cargados
        this.filteredData = this.dataNuevos;
      })
      .catch(error => console.error('Error loading Excel file:', error));
  }

  filterData() {
    const term = this.searchText.trim().toLowerCase();

    if (!term) {
      this.filteredData = this.dataNuevos;
      this.p = 1;
      return;
    }

    this.filteredData = this.dataNuevos.filter(participante => {
      // Buscamos el folio de forma segura
      const folioKey = Object.keys(participante).find(k => k.toLowerCase().trim() === 'folio');
      const folio = folioKey && participante[folioKey] ? participante[folioKey].toString().toLowerCase() : '';
      const folioSinCeros = folio.replace(/^0+/, '');

      // Buscamos el nombre de forma dinámica por si el Excel trae espacios en el encabezado
      const nombreKey = Object.keys(participante).find(k => k.toLowerCase().trim() === 'nombre');
      const nombre = nombreKey && participante[nombreKey] ? participante[nombreKey].toString().toLowerCase() : '';

      return (
        folio.includes(term) ||
        folioSinCeros.includes(term) ||
        nombre.includes(term)
      );
    });

    this.p = 1; // Resetea a la primera página al filtrar
  }

  getInitials(fullName: any) {
    if (!fullName) {
      return '';
    }
    const nameString = fullName.toString().trim();
    const initials = nameString
      .split(/\s+/)
      .map((word: string) => word.charAt(0).toUpperCase())
      .join('. ');
    return initials + '.';
  }
}